import common from './common';
export default {
  baseUrl: common.baseUrl,
  fileUrl: common.fileUrl
}



// WEBPACK FOOTER //
// ./src/utils/url.js